import React, { useCallback, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import "../../../slider.css";

const MultiRangeSlider = ({ min, max, current, callback, step, valueFormatter, unit }) => {
  const [minVal, setMinVal] = useState(min);
  const [maxVal, setMaxVal] = useState(max);
  const [mouseState, setMouseState] = useState(null);
  const minValRef = useRef(min);
  const maxValRef = useRef(max);
  const range = useRef(null);

  const rangeValueFormatter = useCallback((val) => {
      if(typeof valueFormatter === "function") {
          return valueFormatter(val)
      } else {
          return val
      }
  },[valueFormatter])

  const unitFormatter = useCallback(() => {
    if(typeof unit === "string") {
        return unit
    } else {
        return ''
    }
},[unit])

  // Convert to percentage
  const getPercent = useCallback(
    value => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxVal);
    // console.log({minPercent,maxPercent, width: (maxPercent - minPercent)});

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${ (maxPercent - minPercent) }%`;
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${ (maxPercent - minPercent) }%`;
    }
  }, [maxVal, getPercent]);

  useEffect(() => {
    if (mouseState === "up") {
      callback({valueMin: minVal, valueMax: maxVal})
    }
  }, [mouseState])

  useEffect(()=>{
      if( current.min !== null){
          setMinVal( current.min )
      }
      if( current.max !== null ){
        setMaxVal( current.max )
      }
  },[current])

  return (
    <div className="multi-range-container">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={minVal}
        onChange={event => {
          const value = Math.min(Number(event.target.value), maxVal - 1);
          setMinVal(value);
          minValRef.current = value;
        }}
        className="thumb thumb--left"
        style={{ zIndex: minVal > max - 100 && "5" }}
        onMouseDown={() => setMouseState("down")} // When mouse down set the mouseState to 'down'
        onMouseUp={() => setMouseState("up")} // When mouse down set the mouseState to 'up' | now we can call the parent onChnage
        onTouchStart={() => setMouseState("down")}
        onTouchEnd={() => setMouseState("up")}
      />
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={maxVal}
        onChange={event => {
          const value = Math.max(Number(event.target.value), minVal + 1);
          setMaxVal(value);
          maxValRef.current = value;
        }}
        onMouseDown={() => setMouseState("down")} // When mouse down set the mouseState to 'down'
        onMouseUp={() => setMouseState("up")} // When mouse down set the mouseState to 'up' | now we can call the parent onChnage
        onTouchStart={() => setMouseState("down")}
        onTouchEnd={() => setMouseState("up")}
        className="thumb thumb--right"
      />

      <div className="slider">
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
        <div className="slider__left-value">{ rangeValueFormatter( minVal) + unitFormatter() }</div>
        <div className="slider__right-value">{ rangeValueFormatter( maxVal) + unitFormatter() }</div>
      </div>
    </div>
  );
};

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired
};

export default MultiRangeSlider;
